// import React from 'react';
// import mandala from '../../assets/wallpaper.png';

// const WhyChooseUs = () => {
//   const points = [
//     "Every performance is bespoke and tailored to the client’s goals and aligned with their themes, whether for marketing, awareness, or engagement.",
//     "We care deeply about achieving business and social goals of our patrons.",
//     "We research and seek deep insights, craft contextual and bespoke storylines, match the right art & artists, and blend powerful storytelling and musical elements making the message memorable, leaving a lasting experience and creating measurable impact.",
//     "Imagine the transformative power of harnessing traditional performing arts not merely for entertainment but as tools for engagement, connection and behaviour chance to change lives, communities, and the world."
//   ];

//   return (
//     <div className="w-full bg-white mt-[10px] py-20 px-4 flex flex-col items-center relative overflow-hidden">
//       {/* Background Mandalas (Hidden on small screens) */}
//       <img
//         src={mandala}
//         alt="Mandala top right"
//         className="absolute top-[-60px] right-[-210px] w-[500px] opacity-[0.7] z-0 max-[440px]:hidden"
//       />
//       <img
//         src={mandala}
//         alt="Mandala top left"
//         className="absolute top-[-60px] left-[-210px] w-[500px] opacity-[0.7] z-0 max-[440px]:hidden"
//       />

//       <div className="max-w-5xl w-full relative">
//         {/* Heading */}
//         <h2 className="text-center text-[#AD2F3B] mt-[90px] font-bold text-[36px] mb-2 uppercase tracking-wide max-[440px]:text-[20px] max-[440px]:mt-[50px]">
//           WHY CHOOSE US
//         </h2>
//         <div className="w-[350px] h-[1px] bg-[#AD2F3B] mx-auto mt-[1px] mb-[80px] max-[440px]:w-[150px] max-[440px]:mb-[40px]" />

//         {/* Subheading Pill */}
//         <div className="z-10 w-[1000px] mx-auto mb-16 px-6 py-4 border text-center text-[30px] border-[#AD2F3B] text-[#AD2F3B] font-medium rounded-[20px] bg-[#AD2F3B1A] relative max-[440px]:w-full max-[440px]:text-[15px] max-[440px]:px-3 max-[440px]: max-[440px]:mb-10">
//           What makes eKalakaar’s approach unique ??
//         </div>

//         {/* Vertical Line */}
// {/* Vertical Line */}
// <div className="absolute top-[315px] left-1/2 transform -translate-x-1/2 h-[850px] w-1 bg-[#AD2F3B] z-0 max-[440px]:h-[700px] max-[440px]:top-[195px] max-[440px]:w-[2px]" />

//         {/* Points Boxes */}
//         <div className="space-y-10 relative z-10 max-[440px]:space-y-6">
//           {points.map((text, index) => (
//             <div
//               key={index}
//               className="group relative bg-white max-w-[1000px] px-10 py-8 rounded-xl shadow-md border border-gray-200 transition-all duration-300 hover:border-[#AD2F3B] 
//                 mx-auto max-[440px]:px-4 max-[440px]:py-5 max-[440px]:w-[350px]"
//             >
//               <p className="text-center text-[22px] text-gray-700 transition-all duration-300 group-hover:text-[#AD2F3B] group-hover:text-[24px] max-[440px]:text-[14px] group-hover:max-[440px]:text-[14px]">
//                 {text}
//               </p>
//             </div>
//           ))}
//         </div>

//         {/* Bottom Circle */}
//         <div className="absolute bottom-[-80px] left-1/2 transform -translate-x-1/2 z-10 max-[440px]:bottom-[-40px]">
//           <div className="w-8 h-8 bg-[#AD2F3B] rounded-full max-[440px]:w-5 max-[440px]:h-5" />
//         </div>
//       </div>

//       {/* Final Callout */}
//       <h2 className="mt-[120px] text-[32px] text-[#AD2F3B] font-medium text-center max-[440px]:text-[14px] max-[440px]:mt-[80px] max-[440px]:px-4">
//         Let's Collaborate To Create Unforgettable Experiences With Lasting Impact !
//       </h2>
//     </div>
//   );
// };

// export default WhyChooseUs;



import React, { useRef, useEffect, useState } from 'react';
import mandala from '../../assets/wallpaper.png';
import { Link } from "react-router-dom";

const WhyChooseUs = () => {
  const points = [
    "Every performance is bespoke and tailored to the client’s goals and aligned with their themes, whether for marketing, awareness, or engagement.",
    "We care deeply about achieving business and social goals of our patrons.",
    "We research and seek deep insights, craft contextual and bespoke storylines, match the right art & artists, and blend powerful storytelling and musical elements making the message memorable, leaving a lasting experience and creating measurable impact.",
    "Imagine the transformative power of harnessing traditional performing arts not merely for entertainment but as tools for engagement, connection and behaviour chance to change lives, communities, and the world."
  ];

  const pillRef = useRef(null);      // Ref for the pill
  const circleRef = useRef(null);    // Ref for the bottom circle
  const lineRef = useRef(null);      // Ref for the vertical line
  const [lineStyle, setLineStyle] = useState({});

  useEffect(() => {
    const updateLinePosition = () => {
      if (pillRef.current && circleRef.current && lineRef.current) {
        const pillRect = pillRef.current.getBoundingClientRect();
        const circleRect = circleRef.current.getBoundingClientRect();
        const containerTop = lineRef.current.offsetParent.getBoundingClientRect().top;

        const top = pillRect.bottom - containerTop;
        const bottom = circleRect.top - containerTop;

        setLineStyle({
          top: `${top}px`,
          height: `${bottom - top}px`,
        });
      }
    };

    updateLinePosition();
    window.addEventListener('resize', updateLinePosition);
    return () => window.removeEventListener('resize', updateLinePosition);
  }, []);

  return (
    <div className="w-full bg-white mt-[0px] py-20 max-[440px]:pt-4 px-4 flex flex-col items-center relative overflow-hidden">
      {/* Background Mandalas */}
      <img
        src={mandala}
        alt="Mandala top right"
        className="absolute top-[-60px] right-[-210px] w-[500px] opacity-[0.7] z-0 max-[440px]:hidden"
      />
      <img
        src={mandala}
        alt="Mandala top left"
        className="absolute top-[-60px] left-[-210px] w-[500px] opacity-[0.7] z-0 max-[440px]:hidden"
      />

      <div className="max-w-5xl w-full relative">
        {/* Heading */}
        <h2 className="text-center text-[#AD2F3B] mt-[90px] font-bold text-[36px] mb-2 uppercase tracking-wide max-[440px]:text-[20px] max-[440px]:mt-[50px]">
          WHY CHOOSE US
        </h2>
        <div className="w-[350px] h-[1px] bg-[#AD2F3B] mx-auto mt-[1px] mb-[80px] max-[440px]:w-[150px] max-[440px]:mb-[40px]" />

        {/* Subheading Pill */}
        <div
          ref={pillRef}
          className="z-10 w-[1000px] mx-auto mb-16 px-6 py-4 border text-center text-[30px] border-[#AD2F3B] text-[#AD2F3B] font-medium rounded-[20px] bg-[#AD2F3B1A] relative max-[440px]:w-full max-[440px]:text-[15px] max-[440px]:px-3 max-[440px]:mb-10"
        >
          What makes eKalakaar’s approach unique ??
        </div>

        {/* Dynamic Vertical Line */}
        <div
          ref={lineRef}
          className="absolute left-1/2 transform -translate-x-1/2 w-1 bg-[#AD2F3B] z-0 max-[440px]:w-[2px]"
          style={lineStyle}
        />

        {/* Points Boxes */}
        <div className="space-y-10 relative z-10 max-[440px]:space-y-6">
          {points.map((text, index) => (
            <div
              key={index}
              className="group relative bg-white max-w-[1000px] px-10 py-8 rounded-xl shadow-md border border-gray-200 transition-all duration-300 hover:border-[#AD2F3B] mx-auto max-[440px]:px-4 max-[440px]:py-5 max-[440px]:w-[350px]"
            >
              <p className="text-center text-[22px] text-gray-700 transition-all duration-300 group-hover:text-[#AD2F3B] group-hover:text-[24px] max-[440px]:text-[14px] group-hover:max-[440px]:text-[14px]">
                {text}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Circle */}
        <div
          ref={circleRef}
          className="absolute bottom-[-80px] left-1/2 transform -translate-x-1/2 z-10 max-[440px]:bottom-[-40px]"
        >
          <div className="w-8 h-8 bg-[#AD2F3B] rounded-full max-[440px]:w-5 max-[440px]:h-5" />
        </div>
      </div>

      {/* Final Callout */}
 <Link to="/contactpage" className="no-underline">
  <h2 className="animate-pulse mt-[120px] text-[32px] text-[#AD2F3B] font-medium text-center max-[440px]:text-[18px] max-[440px]:mt-[80px] max-[440px]:px-4">
    Let's Collaborate To Create Unforgettable Experiences With Lasting Impact!
  </h2>
</Link>


    </div>
  );
};

export default WhyChooseUs;
